import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// API
import fiscalizacao_api from '../../../api/fiscalizacao_api';

// Helpers
import { showMessage } from '../../../helpers/message';
import { getSessionCookie } from '../../../helpers/cookies';

// Context
import { useAuth } from '../../../context/auth';

// Components
import AutoDeFiscalizacao from '../AutoDeFiscalizacao';
import Loading from '../../../components/Loading/Loading';
import setup_api from '../../../api/setup_api';
import secretaria_api from '../../../api/secretaria_api';

function ConsultaFichaFiscalizacaoViaLink() {
    // Objeto
    const session = getSessionCookie();

    // Pegar a queryString da URL
    const location = useLocation();

    // State para lista de infração
    const [fiscalizacao, setFiscalizacao] = useState(null);

    const { setLoading, loading, setLogoSecretaria, setLogoSistema, setLogoPrefeitura } = useAuth();

    const loadLogoSecretaria = () => {
        secretaria_api.getLogotipo().then(response => {
            setLogoSecretaria(response.data);
        }).catch(ex => showMessage("Erro", ex.Message, "error", null))
            .finally(f => setLoading(false));
    }

    const loadLogoTipos = () => {
        setup_api.GetLogotipos().then(response => {
            setLogoPrefeitura(response.data.logotipoPrefeitura);
            if (response.data.logotipoSistema)
                setLogoSistema(response.data.logotipoSistema);
        }).catch(ex => showMessage("Erro", ex.Message, "error", null))
            .finally(f => setLoading(false));
    }

    const loadFichaInfracao = () => {
        const searchParams = new URLSearchParams(location.search);
        const hash = searchParams.get('hash');

        if (session != null) {
            showMessage("Error", "Esse acesso é exclusivo do infrator.", "error", null);
            setLoading(false);
            return;
        } else {
            setLoading(true);
            fiscalizacao_api
                .GetFiscalizacaoHash(hash)
                .then(response => {
                    setFiscalizacao(response.data)
                })
                .catch(error => showMessage("Error", error.message, "error", null))
                .finally(() => setLoading(false));
        }
    };

    useEffect(() => {
        loadLogoSecretaria();
        loadLogoTipos()
        loadFichaInfracao();
    }, []);

    return <>
        {loading && <Loading />}
        {fiscalizacao && <AutoDeFiscalizacao fichaExterna={fiscalizacao} />}
    </>;
}

export default ConsultaFichaFiscalizacaoViaLink;
